<script>
  // TODO: Удалять неиспользуемый css
  import { fade } from 'svelte/transition';
  import SmartImg from './SmartImg.svelte';

  let yamiCurr = { main: true, menu: true };
  function yamiToggle(what, value) {
    if (value === undefined) {
      yamiCurr[what] = !yamiCurr[what];
    } else {
      yamiCurr[what] = value;
    }
  }

  let iCan = [{
    title: 'Работать в Figma',
    descr: 'Использую Figma с 2018 года, могу сделать кликабельный прототип для смартфона, планшета и десктопа.',
    open: false,
  }, {
    title: 'Создавать визуальный контент в Photoshop',
    descr: 'Если нужна детальная работа с изображением — использую Photoshop. Раньше прототипы тоже делала в Photoshop, но перешла на Figma.',
    open: false,
  }, {
    title: 'Проводить usability-тестирования',
    descr: 'Могу организовать и провести тестирование от А до Я. За время работы в Huawei Technologies составляла сценарии и задания, организовывала процесс и анализировала результаты тестирований.',
    open: false,
  }, {
    title: 'Общаться на английском',
    descr: 'Работала с иностранными заказчиками, несколько месяцев училась в Финляндии и закончила магистратуру на английском.Уровень В2. ',
    open: false,
  }, {
    title: 'Работать вместе с другими людьми',
    descr: 'Входила в состав как интернациональной, так и русской команды. Конфликтов с коллегами не было.',
    open: false,
  }, {
    title: 'Быстро учиться новому',
    descr: 'Стажировалась в Лаборатории Касперского, Netcracker Technology и Центральном Банке России. Две из трёх стажировок закончились приглашением на работу.',
    open: false,
  }];

  function iCanToggle(i) {
    iCan[i].open = !iCan[i].open;
  }
</script>

<main class="font-light pt-45 md:pt-32 sm:pt-20">
  <div class="flex sm:block px-92 md:px-32 sm:px-14 pb-45 sm:pb-0">
    <div class="w-4/10 sm:w-full max-w-520 md:max-w-340 sm:max-w-full flex flex-col sm:flex-row relative">
      <div class="mb-20 md:mb-24 sm:-mb-90 relative sm:w-full sm:max-w-136 sm:flex-shrink-0" style="height: 0; padding-top: calc(1512 / 2016 * 100%); z-index: -1">
        <SmartImg visibleOn="lg md sm" alt="face" src="/img/face.jpg" style="position: absolute; top: 0; left: 0;" />
      </div>
      <div class="text-right sm:text-left sm:pl-10 sm:w-full sm:text-xs">
        <div class="mb-20 md:mb-24 sm:mb-12">
          <h2 class="font-semibold mb-5">
            Дизайнер интерфейсов
          </h2>
          <h2>
            Юлия Ларина
          </h2>
        </div>
        <div class="text-gray">
          <h3 class="mb-5">
            Email: <a class="font-regular text-black" href="mailto:job@ylarina.ru">job@ylarina.ru</a>
          </h3>
          <h3>
            Telegram: <a class="font-regular text-black" href="https://t.me/ylarina">@ylarina</a>
          </h3>
        </div>
      </div>
    </div>

    <div class="w-6/10 sm:w-full pl-40 md:pl-24 sm:pl-0">
      <h1 class="section-title font-semibold mb-12" style="margin-top: -1.1rem;">
        Что умею
      </h1>
      <ul class="max-w-650 md:max-w-full sm:hidden">
        <li class="mb-22 md:mb-16">
          <h2 class="title-underline">
            Работать в Figma
          </h2>
          <p>
            Использую Figma с 2018 года, могу сделать кликабельный прототип 
            для смартфона, планшета и десктопа.
          </p>
        </li>
        <li class="mb-22 md:mb-16">
          <h2 class="title-underline">
            Создавать визуальный контент в Photoshop
          </h2>
          <p>
            Если нужна детальная работа с изображением — использую Photoshop. 
            Раньше прототипы тоже делала в Photoshop, но перешла на Figma.
          </p>
        </li>
        <li class="mb-22 md:mb-16">
          <h2 class="title-underline">
            Проводить usability-тестирования 
          </h2>
          <p>
            Могу организовать и провести тестирование от А до Я. За время работы в Huawei Technologies 
            составляла сценарии и задания, организовывала процесс и анализировала результаты тестирований. 
          </p>
        </li>
        <li class="mb-22 md:mb-16">
          <h2 class="title-underline">
            Общаться на английском
          </h2>
          <p>
            Работала с иностранными заказчиками, несколько месяцев училась в Финляндии 
            и закончила магистратуру на английском.Уровень В2. 
          </p>
        </li>
        <li class="mb-22 md:mb-16">
          <h2 class="title-underline">
            Работать вместе с другими людьми
          </h2>
          <p>
            Входила в состав как интернациональной, так и русской команды. Конфликтов с коллегами не было. 
          </p>
        </li>
        <li class="mb-22 md:mb-16 relative">
          <h2 class="title-underline">
            Быстро учиться новому
          </h2>
          <p>
            Стажировалась в Лаборатории Касперского, Netcracker Technology и Центральном Банке России. 
            Две из трёх стажировок закончились приглашением на работу.
          </p>
          <div class="absolute arrow fill-current">
            <svg width="72" height="28" viewBox="0 0 72 28" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.73922 15.5694L17.963 27.757C18.6702 28.2573 19.5742 27.9603 19.9826 27.0938C20.3909 26.2271 20.1485 25.1191 19.4415 24.6186L6.99109 15.8087L70.5216 15.8087C71.3381 15.8087 72 14.9973 72 13.9967C72 12.9963 71.3381 12.1847 70.5216 12.1847L7.001 12.1847L19.4415 3.38154C20.1486 2.88106 20.3909 1.77304 19.9826 0.90636C19.7086 0.325073 19.2119 -9.61256e-07 18.7009 -9.61256e-07C18.4502 -9.61256e-07 18.1959 0.0786414 17.963 0.24317L0.73922 12.431C0.281791 12.7546 2.23517e-07 13.3529 2.23517e-07 14.0002C2.23517e-07 14.6474 0.281791 15.2457 0.73922 15.5694Z"/>
            </svg>
            <p>
              Кейсы
            </p>
          </div>
        </li>
      </ul>
      <div class="hidden sm:block mb-20">
        {#each iCan as can, i}
          <div class="mb-12">
            <div on:click={() => iCanToggle(i)} class="font-semibold bg-yellow py-4 px-16 rounded-sm-t inline-flex items-center" class:rounded-sm-b={!can.open}>
              <span class="mr-8">
                {can.title}
              </span>
              <span class:arrowFlip={can.open} class="flex items-center flex-shrink-0">
                <svg style="width: 1.1rem; height: 0.7rem" viewBox="0 0 11 7" class="fill-current" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1.57143 0.714286L5.5 4.64286L9.42857 0.714286L11 1.5L5.5 7L0 1.5L1.57143 0.714286Z"/>
                </svg>
              </span>
            </div>
            {#if can.open}
              <div class="py-8 px-14" style="border: 0.2rem solid #FDF7DD; border-top-right-radius: 0.4rem; border-bottom-left-radius: 0.4rem; border-bottom-right-radius: 0.4rem;">
                {can.descr}
              </div>
            {/if}
          </div>
        {/each}
      </div>
    </div>
  </div>

  <div class="bg-yellow sm:bg-transparent px-92 md:px-32 sm:px-60">
    <div class="books">
      <h1 class="section-title font-semibold mb-20 sm:mb-8 text-center">
        Что прочитала
      </h1>
      <div class="sm:hidden">
        <SmartImg alt="books" src="/img/books.png" />
      </div>
      <div class="hidden sm:block">
        <SmartImg alt="books" src="/img/книги без подписей.png" visibleOn="sm" />
      </div>
    </div>
  </div>

  <div class="py-45 px-92 md:px-32 sm:px-14 sm:pb-24">
    <h1 class="section-title font-semibold mb-20 sm:mb-8">
      Что сделала
    </h1>

    <div class="mb-120 sm:mb-36">
      <h2 id="football-stats" class="title-underline text-md mb-7 sm:mb-0">
        Статистика футбольного матча <span class="sm:hidden">для смартфона</span>
      </h2>
      <h2 class="title-underline text-md mb-7 hidden sm:block">
        для смартфона
      </h2>
      <p class="max-w-650 mb-32 sm:mb-24">
        Нужно отобразить большой объём текстовой информации так, чтобы пользователю<br class="sm:hidden"/>
        было удобно воспринимать её на экране смартфона. 
      </p>
      
      <div class="mb-50 sm:mb-20">
        <div class="flex sm:block ">
          <div class="w-1/2 pr-16 flex sm:w-full sm:p-0 sm:block">
            <div class="w-3/5 pr-16 sm:w-full sm:p-0 sm:mb-4">
              <SmartImg src="/img/Статистика/О матче.jpg" visibleOn="sm md lg" className="rounded-lg" />
            </div>
            <div class="w-2/5 cards-19 sm:hidden">
              <div class="descr-card">
                Главная информация закреплена вверху.
              </div>
              <div class="descr-card">
                Наглядно показаны стадион и судейский состав.
              </div>
            </div>
            <div class="hidden sm:block sm:mb-20">
              <div class="descr-card">
                <p>
                  Главная информация закреплена вверху.
                </p>
                <p>
                  Наглядно показаны стадион и судейский состав.
                </p>
              </div>
            </div>
          </div>
          <div class="w-1/2 pl-16 flex sm:w-full sm:p-0 sm:block">
            <div class="w-3/5 pr-16 sm:w-full sm:p-0 sm:mb-4">
              <SmartImg src="/img/Статистика/Состав команд 1.jpg" visibleOn="sm md lg" className="rounded-lg" />
            </div>
            <div class="w-2/5 cards-20 sm:hidden">
              <div class="descr-card">
                Удобный переключатель между разделами.
              </div>
              <div class="descr-card">
                Список игроков можно просматривать в виде карточек или в виде списка.
              </div>
            </div>
            <div class="hidden sm:block sm:mb-20">
              <div class="descr-card">
                <p>
                  Удобный переключатель между разделами.
                </p>
                <p>
                  Список игроков можно просматривать в виде карточек или в виде списка.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="mb-50 sm:mb-20">
        <div class="flex sm:block ">
          <div class="w-1/2 pr-16 flex sm:w-full sm:p-0 sm:block">
            <div class="w-3/5 pr-16 sm:w-full sm:p-0 sm:mb-4">
              <SmartImg src="/img/Статистика/Ход игры.jpg" visibleOn="sm md lg" className="rounded-lg" />
            </div>
            <div class="w-2/5 cards-21 sm:hidden">
              <div class="descr-card">
                Таймлайн игры подаёт информацию компактно и без ущерба понятности.
              </div>
            </div>
            <div class="hidden sm:block sm:mb-20">
              <div class="descr-card">
                Таймлайн игры подаёт информацию компактно и без ущерба понятности.
              </div>
            </div>
          </div>
          <div class="w-1/2 pl-16 flex sm:w-full sm:p-0 sm:block">
            <div class="w-3/5 pr-16 sm:w-full sm:p-0 sm:mb-4">
              <SmartImg src="/img/Статистика/Статистика.jpg" visibleOn="sm md lg" className="rounded-lg" />
            </div>
            <div class="w-2/5 cards-22 sm:hidden">
              <div class="descr-card">
                Статистика обеих команд на одном экране. Удобно сравнивать игру соперников.
              </div>
            </div>
            <div class="hidden sm:block sm:mb-20">
              <div class="descr-card">
                Статистика обеих команд на одном экране. Удобно сравнивать игру соперников.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-120 sm:mb-36">
      <h2 id="yami-yami-redesign" class="title-underline text-md mb-7">
        Редизайн доставки еды Yami Yami
      </h2>
      <p class="max-w-650 mb-50 sm:mb-24">
        Сервис позиционирует себя как доставка ресторанных блюд. Текущий сайт Yami Yami 
        не отражает этот подход. Нужно создать ощущение ресторанного меню,<br/>
        сделать оформление заказа удобнее и встроить в меню информацию об акциях.
      </p>

      <div class="mb-50 sm:mb-28">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Главная страница
        </h3>
        <div class="flex sm:hidden">
          <div class="w-1/5 pr-20 md:hidden">
            <h3 class="font-semibold mb-12">
              {#if yamiCurr.main}
                Было
              {:else}
                Стало
              {/if}
            </h3>
            <div class="mb-20">
              {#if yamiCurr.main}
                <SmartImg on:click={() => yamiToggle('main')} alt="Главная. Было" src="/img/YamiYami/главная было.jpg" className="rounded-lg border-green" />
              {:else}
                <SmartImg on:click={() => yamiToggle('main')} alt="Главная. Стало" src="/img/YamiYami/главная стало.jpg" className="rounded-lg border-violet" />
              {/if}
            </div>
            <div>
              <button on:click={() => yamiToggle('main')} class="bg-blue w-full text-btn text-center rounded py-8 text-dark-blue flex justify-center items-center">
                <span style="width:1.6rem; height:1.6rem; margin-right:1.4rem" class="flex justify-center items-center">
                  <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 16C8.7925 15.9998 9.57481 15.8813 10.3225 15.6528C11.9162 15.1657 13.7827 15.1977 14.9611 16.3761L16.586 18.001C16.9765 18.3915 17.6095 18.3915 18 18.001C18.3905 17.6105 18.3905 16.9775 18 16.587L16.3753 14.9623C15.1968 13.7838 15.165 11.9172 15.6524 10.3235C15.8811 9.57549 15.9998 8.79285 16 8C16 3.589 12.411 0 8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16ZM8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2Z" />
                  </svg>
                </span>
                <span>
                  Увеличить
                </span>
              </button>
            </div>
          </div>
          <div class="w-3/5 md:w-3/4 px-20 md:pl-0">
            <h3 class="font-semibold mb-12 md:hidden">
              {#if yamiCurr.main}
                Стало
              {:else}
                Было
              {/if}
            </h3>

            <div class="toggle hidden md:flex mb-16">
              <div on:click={() => yamiToggle('main', false)} class="item w-1/2 text-center py-7 rounded" class:active={!yamiCurr.main}>
                Старый дизайн
              </div>
              <div on:click={() => yamiToggle('main', true)} class="item w-1/2 text-center py-7 rounded" class:active={yamiCurr.main}>
                Новый дизайн
              </div>
            </div>

            <div>
              {#if yamiCurr.main}
                <SmartImg alt="Главная. Стало" src="/img/YamiYami/главная стало.jpg" className="rounded-lg border-violet" />
              {:else}
                <SmartImg alt="Главная. Было" src="/img/YamiYami/главная было.jpg" className="rounded-lg border-green" />
              {/if}
            </div>
          </div>
          <div class="w-1/5 md:w-1/4 pl-10">
            {#if yamiCurr.main}
              <div class="cards-1">
                <div class="descr-card">
                  Шрифт баннера стал крупнее и ярче.
                </div>

                <div class="descr-card">
                  Анонс меню теперь больше. Выбрала сочные фото блюд из разных категорий.
                </div>

                <div class="descr-card">
                  Разный размер карточек расставляет акценты.
                </div>

                <div class="descr-card">
                  Добавила кнопку «Перейти в меню».
                </div>

                <div class="descr-card">
                  Более яркий блок с информацией о доставке привлекает внимание и побуждает проверить свой адрес.
                </div>

                <div class="descr-card">
                  В футере появилась расшифровка особых разделов. Раньше она была спрятана в кнопке  «Меню».
                </div>
              </div>

            {:else}
              <div class="cards-2">
                <div class="descr-card">
                  Неконтрастный баннер с мелким текстом.
                </div>
                <div class="descr-card">
                  Скучный анонс меню, фотографии неаппетитные и маленького размера.
                </div>
                <div class="descr-card">
                  Едва заметная информация о доставке на фоне серой карты. Создаётся ощущение, что блок неактивен.
                </div>
                <div class="descr-card">
                  В футере не хватает категорий меню и расшифровки особых разделов.
                </div>
              </div>
            {/if}
          </div>
        </div>
        <div class="hidden sm:block">
          <div class="flex mb-16">
            <div on:click={() => yamiToggle('main', false)} class="w-1/2 flex items-center justify-center font-semibold text-sm2 h-40 text-gray-500 rounded" class:activeSwitch={!yamiCurr.main}>
              Было
            </div>
            <div on:click={() => yamiToggle('main', true)} class="w-1/2 flex items-center justify-center font-semibold text-sm2 h-40 text-gray-500 rounded" class:activeSwitch={yamiCurr.main}>
              Стало
            </div>
          </div>
          {#if yamiCurr.main}
            <SmartImg src="/img/YamiYami/Куски/jpg/главная баннер стало.jpg" visibleOn="sm" className="border-violet border-2 mb-4 rounded" />
            <div class="descr-card mb-20">
              Шрифт баннера стал крупнее и ярче.
            </div>
            <SmartImg src="/img/YamiYami/Куски/jpg/главная меню стало.jpg" visibleOn="sm" className="border-violet border-2 mb-4 rounded" />
            <div class="descr-card mb-20">
              <p>
                Анонс меню теперь больше. Выбрала сочные фото блюд из разных категорий.
              </p>
              <p>
                Разный размер карточек расставляет акценты.
              </p>
              <p>
                Добавила кнопку «Перейти в меню».
              </p>
            </div>
            <SmartImg src="/img/YamiYami/Куски/jpg/главная доставка стало.jpg" visibleOn="sm" className="border-violet border-2 mb-4 rounded" />
            <div class="descr-card mb-20">
              Более яркий блок с информацией о доставке привлекает внимание и побуждает проверить свой адрес.
            </div>
            <SmartImg src="/img/YamiYami/Куски/jpg/главная футер стало.jpg" visibleOn="sm" className="border-violet border-2 mb-4 rounded" />
            <div class="descr-card">
              В футере появилась расшифровка особых разделов. Раньше она была спрятана в кнопке  «Меню».
            </div>
          {:else}
            <SmartImg src="/img/YamiYami/Куски/jpg/главная баннер было.jpg" visibleOn="sm" className="border-violet border-2 mb-4 rounded" />
            <div class="descr-card mb-20">
              Неконтрастный баннер с мелким текстом.
            </div>
            <SmartImg src="/img/YamiYami/Куски/jpg/главная меню было.jpg" visibleOn="sm" className="border-violet border-2 mb-4 rounded" />
            <div class="descr-card mb-20">
              Скучный анонс меню, фотографии неаппетитные и маленького размера.
            </div>
            <SmartImg src="/img/YamiYami/Куски/jpg/главная доставка было.jpg" visibleOn="sm" className="border-violet border-2 mb-4 rounded" />
            <div class="descr-card mb-20">
              Едва заметная информация о доставке на фоне серой карты. Создаётся ощущение, что блок неактивен.
            </div>
            <SmartImg src="/img/YamiYami/Куски/jpg/главная футер было.jpg" visibleOn="sm" className="border-violet border-2 mb-4 rounded" />
            <div class="descr-card">
              В футере не хватает категорий меню и расшифровки особых разделов.
            </div>
          {/if}
        </div>
      </div>

      <div class="mb-50 sm:mb-28">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Хэдер
        </h3>
        <div class="sm:hidden">
          <div class="mb-20">
            <h3 class="font-semibold mb-8">
              Было
            </h3>
            <SmartImg alt="Хэдер. Было" src="/img/YamiYami/хэдер было.jpg" className="rounded-lg border-green" />
          </div>
          <div class="mb-20 md:mb-12">
            <h3 class="font-semibold mb-8">
              Стало
            </h3>
            <SmartImg alt="Хэдер. Стало" src="/img/YamiYami/хэдер стало.jpg" className="rounded-lg border-violet" />
          </div>
          <div class="cards-3 flex justify-between items-start">
            <div class="descr-card mr-12 flex-shrink-0">
              Написала режим работы<br/>
              человеческим языком.
            </div>
            <div class="descr-card mr-12 flex-shrink-0">
              Меню стало частью хэдера<br/>
              и не прячется<br/>
              за отдельной кнопкой.
            </div>
            <div class="descr-card mr-12">
              Раньше «Акции» находились в футере,<br class="md:hidden"/>
              теперь они часть меню.
            </div>
            <div class="descr-card">
              В корзине видно не только количество блюд,<br class="md:hidden"/>
              но и стоимость заказа.
            </div>
          </div>
        </div>
        <div class="hidden sm:block">
          <h4 class="font-medium mb-2">
            Было
          </h4>
          <SmartImg src="/img/YamiYami/хэдер было.jpg" visibleOn="sm" className="border-green border-2 rounded mb-9" />

          <h4 class="font-medium mb-2">
            Стало
          </h4>
          <SmartImg src="/img/YamiYami/хэдер стало.jpg" visibleOn="sm" className="border-violet border-2 rounded mb-4" />
          <div class="descr-card">
            <p>
              Написала режим работы человеческим языком.
            </p>
            <p>
              Меню стало частью хэдера и не прячется за отдельной кнопкой.
            </p>
            <p>
              Раньше «Акции» находились в футере, теперь они часть меню.
            </p>
            <p>
              В корзине видно не только количество блюд, но и стоимость заказа.
            </p>
          </div>
        </div>
      </div>

      <div class="mb-50 sm:mb-28">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Меню
        </h3>
        <div class="flex sm:hidden">
          <div class="w-1/5 pr-20 md:hidden">
            <h3 class="font-semibold mb-12">
              {#if yamiCurr.menu}
                Было
              {:else}
                Стало
              {/if}
            </h3>
            <div class="mb-20">
              {#if yamiCurr.menu}
                <SmartImg on:click={() => yamiToggle('menu')} alt="Главная. Было" src="/img/YamiYami/десерты было.jpg" className="rounded-lg border-green" />
              {:else}
                <SmartImg on:click={() => yamiToggle('menu')} alt="Главная. Стало" src="/img/YamiYami/десерты стало.jpg" className="rounded-lg border-violet" />
              {/if}
            </div>
            <div>
              <button on:click={() => yamiToggle('menu')} class="bg-blue w-full text-btn text-center rounded py-8 text-dark-blue flex justify-center items-center">
                <span style="width:1.6rem; height:1.6rem; margin-right:1.4rem" class="flex justify-center items-center">
                  <svg width="19" height="19" viewBox="0 0 19 19" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 16C8.7925 15.9998 9.57481 15.8813 10.3225 15.6528C11.9162 15.1657 13.7827 15.1977 14.9611 16.3761L16.586 18.001C16.9765 18.3915 17.6095 18.3915 18 18.001C18.3905 17.6105 18.3905 16.9775 18 16.587L16.3753 14.9623C15.1968 13.7838 15.165 11.9172 15.6524 10.3235C15.8811 9.57549 15.9998 8.79285 16 8C16 3.589 12.411 0 8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16ZM8 2C11.309 2 14 4.691 14 8C14 11.309 11.309 14 8 14C4.691 14 2 11.309 2 8C2 4.691 4.691 2 8 2Z" />
                  </svg>
                </span>
                <span>
                  Увеличить
                </span>
              </button>
            </div>
          </div>
          <div class="w-3/5 md:w-3/4 px-20 md:pl-0">
            <h3 class="font-semibold mb-12 md:hidden">
              {#if yamiCurr.menu}
                Стало
              {:else}
                Было
              {/if}
            </h3>

            <div class="toggle hidden md:flex mb-16">
              <div on:click={() => yamiToggle('menu', false)} class="item w-1/2 text-center py-7 rounded" class:active={!yamiCurr.menu}>
                Старый дизайн
              </div>
              <div on:click={() => yamiToggle('menu', true)} class="item w-1/2 text-center py-7 rounded" class:active={yamiCurr.menu}>
                Новый дизайн
              </div>
            </div>

            <div>
              {#if yamiCurr.menu}
                <SmartImg alt="Главная. Стало" src="/img/YamiYami/десерты стало.jpg" className="rounded-lg border-violet" />
              {:else}
                <SmartImg alt="Главная. Было" src="/img/YamiYami/десерты было.jpg" className="rounded-lg border-green" />
              {/if}
            </div>
          </div>
          <div class="w-1/5 md:w-1/4 pl-10">
            {#if yamiCurr.menu}
              <div class="cards-4">
                <div class="descr-card mb-40">
                  Использую контрастную шрифтовую пару.
                </div>

                <div class="descr-card mb-40">
                  Структура меню напоминает ресторанное, теперь глазу есть за что зацепиться.
                </div>

                <div class="descr-card mb-40">
                  Разный размер карточек расставляет акценты.
                </div>

                <div class="descr-card mb-40">
                  Плавные линии иконок повторяются в закругленных кнопках, карточках и шрифте.
                </div>

                <div class="descr-card mb-40">
                  Добавила ещё один акцентный цвет — фиолетовый.
                </div>

                <div class="descr-card">
                  В структуру меню встроены анонсы акций.
                </div>
              </div>

            {:else}
              <div class="cards-5">
                <div class="descr-card mb-40">
                  Серый текст теряется на сером фоне.
                </div>
                <div class="descr-card mb-40">
                  Структура меню однообраза. Каждое блюдо похоже на остальные. Заказывать не хочется.
                </div>
                <div class="descr-card mb-40">
                  Иконки и логотип закругленные, а углы фотографий острые. Это вносит дисгармонию.
                </div>
                <div class="descr-card mb-40">
                  Меню не хватает ярких акцентов.
                </div>
                <div class="descr-card">
                  Не понятно как получить скидку на заказ.
                </div>
              </div>
            {/if}
          </div>
        </div>
        <div class="hidden sm:block">
          <div class="flex mb-16">
            <div on:click={() => yamiToggle('menu', false)} class="w-1/2 flex items-center justify-center font-semibold text-sm2 h-40 text-gray-500 rounded" class:activeSwitch={!yamiCurr.menu}>
              Было
            </div>
            <div on:click={() => yamiToggle('menu', true)} class="w-1/2 flex items-center justify-center font-semibold text-sm2 h-40 text-gray-500 rounded" class:activeSwitch={yamiCurr.menu}>
              Стало
            </div>
          </div>
          {#if yamiCurr.menu}
            <SmartImg visibleOn="sm" src="/img/YamiYami/десерты стало.jpg" className="rounded border-violet border-2 mb-4" />
            <div class="descr-card">
              <p>
                Использую контрастную шрифтовую пару.
              </p>
              <p>
                Структура меню напоминает ресторонное, теперь глазу есть за что зацепиться.
              </p>
              <p>
                Плавные линии иконок повторяются в закругленных кнопках, карточках и шрифте.
              </p>
              <p>
                Добавила ещё один акцентный цвет — фиолетовый.
              </p>
              <p>
                В структуру меню встроены анонсы акций.
              </p>
            </div>
          {:else}
            <SmartImg visibleOn="sm" src="/img/YamiYami/десерты было.jpg" className="rounded border-violet border-2 mb-4" />
            <div class="descr-card">
              <p>
                Серый текст теряется на сером фоне.
              </p>
              <p>
                Структура меню однообраза. Каждое блюдо похоже на остальные. Заказывать не хочется.
              </p>
              <p>
                Иконки и логотип закругленные, а углы фотографий острые. Это вносит дисгармонию.
              </p>
              <p>
                Меню не хватает ярких акцентов.
              </p>
              <p>
                Не понятно как получить скидку на заказ.
              </p>
            </div>
          {/if}
        </div>
      </div>

      <div class="mb-50 sm:mb-28">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Карточки
        </h3>
        <div class="sm:hidden">
          <div class="flex mb-40">
            <div class="w-4/5 md:w-3/4 flex">
              <div class="w-1/2 pr-20 md:pr-10">
                <h3 class="font-semibold mb-12">
                  Было
                </h3>
                <SmartImg alt="Карточка мини. Было" src="/img/YamiYami/карточка мини было.jpg" />
              </div>
              <div class="w-1/2 px-20 md:px-10">
                <h3 class="font-semibold mb-12">
                  Стало
                </h3>
                <SmartImg alt="Карточка мини. Стало" src="/img/YamiYami/карточка мини стало.jpg" />
              </div>
            </div>
            <div class="cards-6 w-1/5 md:w-1/4 pl-10">
              <div class="descr-card">
                Увеличились размер и разрешение фотографий.
              </div>
              <div class="descr-card">
                Ингредиенты перечислены в порядке значимости.
              </div>
            </div>
          </div>

          <div class="flex mb-40">
            <div class="w-4/5 md:w-3/4 flex">
              <div class="w-1/2 pr-20 md:pr-10">
                <h3 class="font-semibold mb-12">
                  Было
                </h3>
                <SmartImg alt="Карточка. Было" src="/img/YamiYami/карточка было.jpg" className="border-green rounded" />
              </div>
              <div class="w-1/2 px-20 md:px-10">
                <h3 class="font-semibold mb-12">
                  Стало
                </h3>
                <SmartImg alt="Карточка. Стало" src="/img/YamiYami/карточка стало.jpg" className="mb-12 border-violet rounded" />
                <div class="flex justify-center">
                  <SmartImg alt="Карточка пояснение" src="/img/YamiYami/пояснение.png" className="border-violet rounded-full" style="width:20rem; height:20rem;" />
                </div>
              </div>
            </div>
            <div class="cards-7 w-1/5 md:w-1/4 pl-10">
              <div class="descr-card">
                Если навести курсор на условное обозначение — появится пояснение. 
                Раньше пояснения нужно было искать в меню, которое пряталось за кнопкой.
              </div>
            </div>
          </div>

          <div class="flex mb-40">
            <div class="w-4/5 md:w-3/4 flex">
              <div class="w-1/2 pr-20 md:pr-10">
                <h3 class="font-semibold mb-12">
                  Было
                </h3>
                <SmartImg alt="Карточка с выбором. Было" src="/img/YamiYami/карточка с выбором было.jpg" className="border-green rounded" />
              </div>
              <div class="w-1/2 px-20 md:px-10">
                <h3 class="font-semibold mb-12">
                  Стало
                </h3>
                <SmartImg alt="Карточка с выбором. Стало" src="/img/YamiYami/карточка с выбором стало.jpg" className="border-violet rounded" />
              </div>
            </div>
            <div class="cards-8 w-1/5 md:w-1/4 pl-10">
              <div class="descr-card">
                Более компактное расположение без потери информативности.
              </div>
              <div class="descr-card">
                Одинаковые блюда разных объёмов находятся в одной карточке. 
                Раньше это были две разные карточки.
              </div>
            </div>
          </div>
        </div>
        <div class="hidden sm:block">
          <h4 class="font-medium mb-5">
            Было
          </h4>
          <SmartImg src="/img/YamiYami/карточка мини было.jpg" visibleOn="sm" className="border-green border-2 rounded mb-16" />

          <h4 class="font-medium mb-5">
            Стало
          </h4>
          <SmartImg src="/img/YamiYami/карточка мини стало.jpg" visibleOn="sm" className="border-violet border-2 rounded mb-4" />
          <div class="descr-card mb-20">
            <p>
              Увеличились размер и разрешение фотографий.
            </p>
            <p>
              Ингредиенты перечислены в порядке значимости.
            </p>
          </div>

          <h4 class="font-medium mb-5">
            Было
          </h4>
          <SmartImg src="/img/YamiYami/карточка было.jpg" visibleOn="sm" className="border-green border-2 rounded mb-16" />

          <h4 class="font-medium mb-5">
            Стало
          </h4>
          <SmartImg src="/img/YamiYami/карточка стало.jpg" visibleOn="sm" className="border-violet border-2 rounded mb-4" />
          <div class="flex items-center justify-center">
            <SmartImg src="/img/YamiYami/пояснение.png" visibleOn="sm" className="rounded-full border-violet border-2 mb-4 w-2/3" />
          </div>
          <div class="descr-card mb-20">
            <p>
              Если навести курсор на условное обозначение — появится пояснение. Раньше пояснения нужно было искать в меню, которое пряталось за кнопкой.
            </p>
            <p>
              Более компактное расположение без потери информативности.
            </p>
          </div>

          <h4 class="font-medium mb-5">
            Было
          </h4>
          <SmartImg src="/img/YamiYami/карточка с выбором было.jpg" visibleOn="sm" className="border-green border-2 rounded mb-16" />
          <h4 class="font-medium mb-5">
            Стало
          </h4>
          <SmartImg src="/img/YamiYami/карточка с выбором стало.jpg" visibleOn="sm" className="border-violet border-2 rounded mb-4" />
          <div class="descr-card">
            Одинаковые блюда разных объёмов находятся в одной карточке. Раньше это были две разные карточки.
          </div>
        </div>
      </div>
      
      <div class="mb-50 sm:mb-28">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Корзина и оформление заказа
        </h3>
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 flex">
            <div class="w-1/4 pr-20 md:pr-10">
              <h3 class="font-semibold mb-12">
                Было
              </h3>
              <SmartImg alt="Оформление заказа. Было" src="/img/YamiYami/оформление заказа было.jpg" className="rounded-lg border-violet" />
            </div>
            <div class="w-3/4 px-20 md:px-10">
              <h3 class="font-semibold mb-12">
                Стало
              </h3>
              <SmartImg alt="Корзина. Стало" src="/img/YamiYami/корзина стало.jpg" className="rounded-lg border-violet mb-20" />
              <SmartImg alt="Оформление заказа. Стало" src="/img/YamiYami/оформление заказа стало.jpg" className="rounded-lg border-violet" />
            </div>
          </div>
          <div class="cards-9 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              Можно посмотреть и изменить содержимое корзины до перехода к оформлению заказа.
            </div>
            <div class="descr-card">
              Удобная, широкая форма для заказа. Можно проверить содержимое заказа 
              не только по названиям, но и по картинкам.
            </div>
            <div class="descr-card">
              Оплата на одной странице с оформлением заказа.
            </div>
          </div>
        </div>
        <div class="hidden sm:block">
          <h4 class="font-medium mb-5">
            Было
          </h4>
          <SmartImg src="/img/YamiYami/оформление заказа было.jpg" visibleOn="sm" className="border-green border-2 rounded mb-16" />
          <h4 class="font-medium mb-5">
            Стало
          </h4>
          <SmartImg src="/img/YamiYami/корзина стало.jpg" visibleOn="sm" className="border-violet border-2 rounded mb-4" />
          <SmartImg src="/img/YamiYami/оформление заказа стало.jpg" visibleOn="sm" className="border-violet border-2 rounded mb-4" />
          <div class="descr-card">
            <p>
              Можно посмотреть и изменить содержимое корзины до перехода к оформлению заказа.
            </p>
            <p>
              Удобная, широкая форма для заказа. Можно проверить содержимое заказа не только по названиям, но и по картинкам.
            </p>
            <p>
              Оплата на одной странице с оформлением заказа.
            </p>
          </div>
        </div>
      </div>

      <div>
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Алгоритм покупки
        </h3>
        <div class="flex sm:flex-col">
          <div class="w-4/5 md:w-3/4 sm:w-full pr-20 md:pr-10 sm:pr-0 sm:mb-4">
            <div class="video-inside">
              <iframe title="Yami Yami Шоурил" src="https://player.vimeo.com/video/490494743?loop=1" width="640" height="360" frameborder="0" allow="fullscreen; picture-in-picture" allowfullscreen class="rounded"></iframe>
            </div>
          </div>
          <div class="cards-10 w-1/5 md:w-1/4 sm:w-full pl-10 sm:pl-0">
            <div class="descr-card">
              В этом видео — алгоритм покупки на обновлённом сайте Yami Yami.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-120 sm:mb-36">
      <h2 id="corporation-landing" class="title-underline text-md mb-7 sm:mb-0">
        Личный кабинет и корпоративный <span class="sm:hidden">лендинг</span>
      </h2>
      <h2 class="title-underline text-md mb-7 hidden sm:block">
        лендинг
      </h2>
      <p class="max-w-650 mb-50 sm:mb-24">
        Лендинг должен транслировать строгость и сдержанность, а личный кабинет нужно <br/>
        спроектировать с упором на удобство и лёгкость.
      </p>
      
      <div class="mb-50 sm:mb-24">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Подготовка
        </h3>
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 flex">
            <div class="w-6/10 pr-20 md:pr-10">
              <SmartImg alt="User persona. Антон" src="/img/Астерос/User Persona 2.jpg" className="rounded-lg mb-20" style="border: 2px solid rgba(106, 169, 212, 0.3);"/>
              <SmartImg alt="CJM" src="/img/Астерос/CJM.jpg" className="rounded-lg" style="border: 2px solid rgba(106, 169, 212, 0.3);"/>
            </div>
            <div class="w-4/10 px-20 md:px-10">
              <SmartImg alt="User persona. Ольга" src="/img/Астерос/User Persona 1.jpg" className="rounded-lg mb-12" style="border: 2px solid rgba(105, 108, 211, 0.3);"/>
              <SmartImg alt="User persona. Юрий" src="/img/Астерос/User Persona 3.jpg" className="rounded-lg mb-12" style="border: 2px solid rgba(211, 105, 105, 0.3);"/>
              <SmartImg alt="Wireframe. Расписание" src="/img/Астерос/Wireframe 1.jpg" className="rounded-lg mb-12" style="border: 2px solid #ECECEC;"/>
              <SmartImg alt="Wireframe. Лицензии" src="/img/Астерос/Wireframe 2.jpg" className="rounded-lg" style="border: 2px solid #ECECEC;"/>
            </div>
          </div>
          <div class="cards-11 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              До начала прототипирования сделала несколько структурированных user personas. 
            </div>
            <div class="descr-card mb-92">
              Составила Customer Journey Map.
            </div>
            <div class="descr-card">
              Отрисовала мокапы будущих страниц.
            </div>
          </div>
        </div>
        <div class="hidden sm:block">
          <SmartImg visibleOn="sm" src="/img/Астерос/User Persona 2.jpg" className="rounded mb-16 border-2" style="border: solid rgba(106, 169, 212, 0.3);"/>
          <SmartImg visibleOn="sm" src="/img/Астерос/User Persona 1.jpg" className="rounded mb-16 border-2" style="border: solid rgba(105, 108, 211, 0.3);"/>
          <SmartImg visibleOn="sm" src="/img/Астерос/User Persona 3.jpg" className="rounded mb-4 border-2" style="border: solid rgba(211, 105, 105, 0.3);"/>
          <div class="descr-card mb-20">
            До начала прототипирования сделала несколько структурированных user personas. 
          </div>

          <SmartImg visibleOn="sm" src="/img/Астерос/CJM.jpg" className="rounded mb-4 border-2" style="border: solid rgba(106, 169, 212, 0.3);"/>
          <div class="descr-card mb-20">
            Составила Customer Journey Map.
          </div>

          <SmartImg visibleOn="sm" src="/img/Астерос/Wireframe 1.jpg" className="rounded mb-16 border-2" style="border: solid #ECECEC;"/>
          <SmartImg visibleOn="sm" src="/img/Астерос/Wireframe 2.jpg" className="rounded mb-4 border-2" style="border: solid #ECECEC;"/>
          <div class="descr-card">
            Отрисовала мокапы будущих страниц.
          </div>
        </div>
      </div>
    
      <div class="mb-50 sm:mb-24">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Лендинг
        </h3>
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 pr-20 md:pr-10">
            <SmartImg alt="Лендинг" src="/img/Астерос/лендинг.jpg" className="rounded-lg" style="border: 2px solid #D2E5F2" />
          </div>
          <div class="cards-12 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              Острые углы и сдержанная цветовая гамма подчеркивают строгость.
            </div>
            <div class="descr-card">
              Изображения выдержаны в схожей тональности, чтобы не выбиваться из общего настроения.
            </div>
            <div class="descr-card">
              Акцентные блоки не перегружены информацией.
            </div>
            <div class="descr-card">
              Подробная карта сайта в футере.
            </div>
          </div>
        </div>
        <div class="hidden sm:block">
          <SmartImg visibleOn="sm" src="/img/Астерос/куски/лендинг верх.jpg" className="rounded mb-4 border-2 border-solid" style="border-color: rgba(106, 169, 212, 0.3);"/>
          <div class="descr-card mb-20">
            Острые углы и сдержанная цветовая гамма подчеркивают строгость.
          </div>
          <SmartImg visibleOn="sm" src="/img/Астерос/куски/лендинг карточки.jpg" className="mb-4 border-2 rounded border-solid" style="border-color: rgba(106, 169, 212, 0.3);"/>
          <div class="descr-card mb-20">
            Изображения выдержаны в схожей тональности, чтобы не выбиваться из общего настроения.
          </div>
          <SmartImg visibleOn="sm" src="/img/Астерос/куски/лендинг блоки.jpg" className="mb-4 border-2 rounded border-solid" style="border-color: rgba(106, 169, 212, 0.3);"/>
          <div class="descr-card mb-20">
            Акцентные блоки не перегружены информацией.
          </div>
          <SmartImg visibleOn="sm" src="/img/Астерос/куски/лендинг футер.jpg" className="rounded mb-4 border-2 border-solid" style="border-color: rgba(106, 169, 212, 0.3);"/>
          <div class="descr-card">
            Подробная карта сайта в футере.
          </div>
        </div>
      </div>
    
      <div class="mb-50 sm:mb-24">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Меню
        </h3>
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 pr-20 md:pr-10">
            <SmartImg alt="Mega Menu" src="/img/Астерос/mega menu.jpg" className="rounded-lg" style="border: 2px solid rgba(106, 169, 212, 0.3);" />
          </div>
          <div class="cards-13 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              Широкое мегаменю с понятной иерархией разделов.
            </div>
          </div>
        </div>
        <div class="hidden sm:block">
          <SmartImg visibleOn="sm" src="/img/Астерос/mega menu.jpg" className="rounded mb-4 border-2 border-solid" style="border-color: rgba(106, 169, 212, 0.3);"/>
          <div class="descr-card">
            Широкое мегаменю с понятной иерархией разделов.
          </div>
        </div>
      </div>
    
      <div class="mb-50 sm:mb-24">
        <h3 class="text-md sm:text-16 mb-20 sm:mb-8 sm:font-light">
          Личный кабинет
        </h3>
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 pr-20 md:pr-10">
            <SmartImg alt="Лицензии. Заказать 1" src="/img/Астерос/Лицензии - Заказать - 1.jpg" className="rounded-lg" style="border: 2px solid rgba(106, 169, 212, 0.3);" />
          </div>
          <div class="cards-14 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              Пока пользователь не начал составлять новый заказ, вместо пустого экрана виден прошлый заказ. 
              Это помогает начать покупку.
            </div>
            <div class="descr-card">
              Раздел «Ссылки на ресурсы» ускоряет рабочий процесс.
            </div>
            <div class="descr-card">
              Кнопка «Повторить» для клиентов, которые покупают одинаковый софт несколько раз.
            </div>
          </div>
        </div>
        <div class="hidden sm:block">
          <SmartImg visibleOn="sm" src="/img/Астерос/Лицензии - Заказать - 1.jpg" className="rounded border-blue border-2 mb-4" />
          <div class="descr-card mb-20">
            <p>
              Пока пользователь не начал составлять новый заказ, вместо пустого экрана виден прошлый заказ. Это помогает начать покупку.
            </p>
            <p>
              Раздел «Ссылки на ресурсы» ускоряет рабочий процесс.
            </p>
            <p>
              Кнопка «Повторить» для клиентов, которые покупают одинаковый софт несколько раз.
            </p>
            <p>
              Лаконичная навигация.
            </p>
          </div>
          <SmartImg visibleOn="sm" src="/img/Астерос/Лицензии - Заказать - 3.jpg" className="rounded border-blue border-2 mb-4" />
          <div class="descr-card mb-20">
            Визуальное разделение текущего и прошлого заказов с помощью цвета.
          </div>
          <SmartImg visibleOn="sm" src="/img/Астерос/Лицензии - Заказать - 2.jpg" className="rounded border-blue border-2 mb-4" />
          <div class="descr-card mb-20">
            Множественный выбор внутри поиска.
          </div>
          <SmartImg visibleOn="sm" src="/img/Астерос/Лицензии - Заказать - 4.jpg" className="rounded border-blue border-2 mb-4" />
          <div class="descr-card mb-20">
            Оповещение об отправке заказа сформулировала человеческим языком.
          </div>
          <SmartImg visibleOn="sm" src="/img/Астерос/Лицензии - Продлить.jpg" className="rounded border-blue border-2 mb-4" />
          <div class="descr-card mb-20">
            Сразу видны краткое описание программы и иконки с типами устройств.
          </div>
          <SmartImg visibleOn="sm" src="/img/Астерос/Расписание.jpg" className="rounded border-blue border-2 mb-4" />
          <div class="descr-card">
            <p>
              Над календарем добавила разделение на типы встреч.
            </p>
            <p>
              Текущий день недели выделен цветом.
            </p>
            <p>
              Все дни недели помещаются на одном экране.
            </p>
          </div>
        </div>
      </div>

      <div class="mb-50 sm:hidden">
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 pr-20 md:pr-10 relative">
            <SmartImg alt="Лицензии. Заказать 2" src="/img/Астерос/Лицензии - Заказать - 3.jpg" className="rounded-lg w-1/2 mb-12" style="border: 2px solid rgba(106, 169, 212, 0.3);" />
            <SmartImg alt="Лицензии. Заказать 3" src="/img/Астерос/Лицензии - Заказать - 4.jpg" className="rounded-lg w-1/2" style="border: 2px solid rgba(106, 169, 212, 0.3);" />
            <SmartImg alt="Лицензии. Заказать 4" src="/img/Астерос/Лицензии - Заказать - 2.jpg" className="rounded-lg absolute" style="border: 2px solid rgba(106, 169, 212, 0.3); top: 34%; left: 40%; width: calc(58% + 2px);" />
          </div>
          <div class="cards-15 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              Визуальное разделение текущего и прошлого заказов с помощью цвета.
            </div>
            <div class="descr-card">
              Лаконичная навигация.
            </div>
            <div class="descr-card">
              Множественный выбор внутри поиска.
            </div>
            <div class="descr-card">
              Оповещение об отправке заказа сформулировала человеческим языком.
            </div>
          </div>
        </div>
      </div>

      <div class="mb-50 sm:hidden">
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 pr-20 md:pr-10">
            <SmartImg alt="Лицензии. Продлить" src="/img/Астерос/Лицензии - Продлить.jpg" className="rounded-lg" style="border: 2px solid rgba(106, 169, 212, 0.3);" />
          </div>
          <div class="cards-16 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              Сразу видны краткое описание программы и иконки с типами устройств.
            </div>
          </div>
        </div>
      </div>
    
      <div class="mb-50 sm:hidden">
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 pr-20 md:pr-10">
            <SmartImg alt="Расписание" src="/img/Астерос/Расписание.jpg" className="rounded-lg" style="border: 2px solid rgba(106, 169, 212, 0.3);" />
          </div>
          <div class="cards-17 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              Над календарем добавила разделение на типы встреч.
            </div>
            <div class="descr-card">
              Текущий день недели выделен цветом.
            </div>
            <div class="descr-card">
              Все дни недели помещаются на одном экране.
            </div>
          </div>
        </div>
      </div>
    </div>
  
    <div>
      <h2 id="corporation-landing" class="title-underline text-md mb-7">
        Лендинг небольшого турагентства
      </h2>
      <p class="max-w-650 mb-50 sm:mb-16">
        Нужно привлечь путешественников, которые хотят отдохнуть от мегаполиса и сделать атмосферные снимки природы. 
        Необходимо использовать красочные фотографии природы России, рассказать о турах и компании, но не перегружать 
        информацией и выдержать спокойную цветовую гамму.
      </p>

      <div>
        <div class="flex sm:hidden">
          <div class="w-4/5 md:w-3/4 pr-20 md:pr-10">
            <SmartImg alt="Открой Россию" src="/img/Открой Россию/Открой Россию.jpg" className="rounded-lg" style="border: 2px solid rgba(93, 119, 180, 0.2)" />
          </div>
          <div class="cards-18 w-1/5 md:w-1/4 pl-10">
            <div class="descr-card">
              Акцент на фотографии.
            </div>
            <div class="descr-card">
              Минималистичная навигация по разделам.
            </div>
            <div class="descr-card">
              Вместо длинного описания агентства несколько ключевых фактов и короткое видео.
            </div>
            <div class="descr-card"> 
              Три основых тура видны сразу, остальные спрятаны, чтобы не загромождать пространство.
            </div>
            <div class="descr-card">
              Выделила ключевую информацию в виде тегов.
            </div>
            <div class="descr-card">
              Живописное фото усиливает впечатление от отзыва.
            </div>
            <div class="descr-card">
              Оформление блога с использованием кадров природы.
            </div>
            <div class="descr-card">
              Честно написано о том, за что придётся платить отдельно.
            </div>
          </div>
        </div>
        <div class="hidden sm:block">
          <SmartImg visibleOn="sm" src="/img/Открой Россию/куски/открой Россию верх.jpg" className="rounded border-2 border-trevel mb-4" />
          <div class="descr-card mb-20">
            <p>
              Акцент на фотографии.
            </p>
            <p>
              Минималистичная навигация по разделам.
            </p>
          </div>
          <SmartImg visibleOn="sm" src="/img/Открой Россию/куски/открой Россию о нас.jpg" className="rounded border-2 border-trevel mb-4" />
          <div class="descr-card mb-20">
            Вместо длинного описания агентства несколько ключевых фактов и короткое видео.
          </div>
          <SmartImg visibleOn="sm" src="/img/Открой Россию/куски/открой Россию наши путешествия.jpg" className="rounded border-2 border-trevel mb-4" />
          <div class="descr-card mb-20">
            <p>
              Три основых тура видны сразу, остальные спрятаны, чтобы не загромождать пространство.
            </p>
            <p>
              Выделила ключевую информацию в виде тегов.
            </p>
          </div>
          <SmartImg visibleOn="sm" src="/img/Открой Россию/куски/открой Россию отзывы.jpg" className="rounded border-2 border-trevel mb-4" />
          <div class="descr-card mb-20">
            Живописное фото усиливает впечатление от отзыва.
          </div>
          <SmartImg visibleOn="sm" src="/img/Открой Россию/куски/открой Россию блог.jpg" className="rounded border-2 border-trevel mb-4" />
          <div class="descr-card mb-20">
            Оформление блога с использованием кадров природы.
          </div>
          <SmartImg visibleOn="sm" src="/img/Открой Россию/куски/открой Россию низ.jpg" className="rounded border-2 border-trevel mb-4" />
          <div class="descr-card">
            Честно написано о том, за что придётся платить отдельно.
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="pb-45 px-92 md:px-32 sm:px-14">
    <h1 class="section-title font-semibold mb-12">
      Контакты
    </h1>
    <div class="text-gray">
      <p class="font-semibold text-black mb-8">
        Юлия Ларина
      </p>
      <p class="mb-8">
        Email: <a class="font-regular text-black" href="mailto:job@ylarina.ru">job@ylarina.ru</a>
      </p>
      <p>
        Telegram: <a class="font-regular text-black" href="https://t.me/ylarina">@ylarina</a>
      </p>
    </div>
  </div>
</main>

<style>
main {
  font-size: 1.6rem;
  line-height: 1.36;
}

button {
  box-shadow: none;
  border: none;
}

a {
  text-decoration: none;
}

svg {
  max-width: 100%;
  max-height: 100%;
}

.books {
  padding-top: 4.5rem;
  padding-bottom: 7.5rem;
}

.toggle {
  color: #B3B3B3;
  cursor: pointer;
}

.toggle .item:hover {
  color: #757575
}

.toggle .active {
  background: #7CD1B2;
  color: white;
}

.toggle .active.item:hover {
  color: white;
}

.descr-card {
  border-radius: 1rem;
  background-color: rgba(253, 245, 213, 0.7);
  padding: 2rem;
}

@media (min-width: 960px) and (max-width: 1439px) {
  .descr-card {
    font-size: 1.4rem;
  }
}

.arrow {
  transform: rotate(-90deg);
  right: -20rem;
  bottom: 7.3rem;
  color: rgba(211, 208, 195, 0.8);
  display: flex;
  align-items: center;
}

.arrow > p {
  font-weight: 700;
  font-size: 3rem;
  margin-left: 2rem;
}

.arrow > svg {
  width: calc(1rem * 7.2);
  height: calc(1rem * 2.8);
}

@media (min-width: 960px) and (max-width: 1439px) {
  .arrow {
    left: -10.7rem;
    bottom: 5.9rem;
    right: auto;
    color: rgba(211, 208, 195, 0.5);
  }

  .arrow > p {
    font-size: 2rem;
  }

  .arrow > svg {
    width: calc(0.8rem * 7.2);
    height: calc(0.8rem * 2.8);
  }
}

.title-underline {
  display: inline-block;
  position: relative;
  font-weight: 600;
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
}

.title-underline + .hidden {
  display: none;
}

.title-underline::after {
  content: '';
  display: block;
  position: absolute;
  width: calc(100% + 2.4rem);
  height: 0.75em;
  background-color: rgba(253, 245, 213, 0.8);
  top: 0.8em;
  z-index: -1;
}

.video-inside {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
}

.video-inside iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.section-title {
  font-size: 3.2rem;
}

@media (max-width: 959px) {
  main {
    font-size: 1.4rem;
  }

  .section-title {
    font-size: 2rem;
  }

  .title-underline {
    font-size: 1.6rem;
    font-weight: 500;
  }

  .title-underline + .hidden {
    display: inline-block;
  }

  .books {
    padding-top: 0;
    padding-bottom: 0;
  }

  .descr-card {
    padding: 2rem 1.4rem;
    border-radius: 0.4rem;
  }

  .descr-card > p {
    margin-bottom: 1.6rem;
  }

  .descr-card > p:last-child {
    margin-bottom: 0;
  }

  .activeSwitch {
    color: white;
    background: #7CD1B2;
  }

  .arrowFlip {
    transform: rotate(180deg);
  }
}
</style>